import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { getDrugTypes } from "../../../api/group";
import CustomizedHook from "../../project/autocomplatePro";
import { InputCreateProject } from "../../project/createProjectPop";
import DatePicker from "../../project/datePicker";

export default function FormDrug({
  dataForm,
  setDataForm,
  date,
  setDate,
  edit,
}) {
  const [drugType, setDrugType] = useState([]);
  const [showDatePicker, setShowDatePicker] = useState();

  useEffect(() => {
    getDrugTypes()
      .then((x) => setDrugType(x.map((name) => ({ value: name }))))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!edit) {
      if (date) {
        setDataForm({ ...dataForm, expireAt: date?.toUnix() * 1000 });
      }
    } else {
      if (date) {
        // setDataForm({ ...dataForm, expireAt: date?.toUnix() * 1000 });
      }
    }
  }, [date]);

  return (
    <>
      <DatePicker
        sx={{ marginLeft: "-30px !important" }}
        date={date}
        setDate={setDate}
        show={showDatePicker}
        setShow={setShowDatePicker}
        notRange
      />
      <Box display={"flex"} flexWrap="wrap" gap="10px">
        <Box width={"250px"}>
          <CustomizedHook
            placeholder={"انتخاب کنید."}
            label="نوع دارو"
            options={drugType}
            onChange={(_, newValue) => {
              if (newValue) {
                setDataForm({ ...dataForm, drugType: newValue.value });
              }
            }}
            value={
              drugType?.find((x) => x.value === dataForm?.drugType) || null
            }
          />
        </Box>
        <InputCreateProject
          placeholder={"تاریخ انقضا دارو"}
          label="تاریخ انقضا"
          onClick={(e) => {
            setShowDatePicker(e.currentTarget);
          }}
          value={
            date
              ? `${date.year}/${date.month}/${date.day} `
              : dataForm?.expireAt
                ? dataForm?.expireAt?.split("T", 2)[0] || ""
                : ""
          }
          //   onChange={(e) => setTripName(e.target.value)}
        />
        <InputCreateProject
          placeholder={"نام دارو را وارد کنید."}
          label="اسم دارو"
          onChange={(e) => setDataForm({ ...dataForm, name: e.target.value })}
          value={dataForm?.name || ""}
        />
        <InputCreateProject
          placeholder={"کد دارو را وارد کنید."}
          label="کد دارو"
          onChange={(e) => setDataForm({ ...dataForm, code: e.target.value })}
          value={dataForm?.code || ""}
        />
        <InputCreateProject
          placeholder={"دوز دارو را وارد کنید"}
          label="دوز دارو"
          onChange={(e) => setDataForm({ ...dataForm, dose: e.target.value })}
          value={dataForm?.dose || ""}
        />
        <InputCreateProject
          placeholder={"شرکت سازنده دارو را وارد کنید"}
          label="شرکت سازنده"
          onChange={(e) =>
            setDataForm({ ...dataForm, producer: e.target.value })
          }
          value={dataForm?.producer || ""}
        />
        <Box width={"250px"}>
          <CustomizedHook
            placeholder={"انتخاب کنید."}
            label="محل دارو"
            options={[{ value: "MAIN" }, { value: "FUNCTIONAL" }]}
            onChange={(event, newValue) => {
              if (newValue) {
                setDataForm({ ...dataForm, location: newValue.value });
              }
            }}
            value={
              [{ value: "MAIN" }, { value: "FUNCTIONAL" }].find(
                (x) => x.value === dataForm?.location,
              ) || null
            }
          />
        </Box>
        <InputCreateProject
          placeholder={"تعداد دارو را وارد کنید"}
          label="تعداد دانه"
          onChange={(e) =>
            setDataForm({ ...dataForm, available: Number(e.target.value) })
          }
          value={dataForm?.available || ""}
          type="number"
        />
        <InputCreateProject
          placeholder={"تعداد بک دارو را وارد کنید"}
          label="تعداد پک"
          onChange={(e) =>
            setDataForm({
              ...dataForm,
              availablePack: Number(e.target.value),
            })
          }
          value={dataForm?.availablePack || ""}
          type="number"
        />
        <InputCreateProject
          placeholder={"مبلغ دارو را وارد کنید"}
          label="مبلغ یک دانه"
          onChange={(e) =>
            setDataForm({ ...dataForm, price: Number(e.target.value) })
          }
          value={dataForm?.price || ""}
          type="number"
        />
        <InputCreateProject
          placeholder={"مبلغ کل دارو را وارد کنید"}
          label="مبلغ کل"
          value={dataForm?.price * dataForm?.available || ""}
        />
        <InputCreateProject
          placeholder={"شماره دارو را وارد کنید"}
          label="شماره جعبه"
          onChange={(e) => setDataForm({ ...dataForm, boxNo: e.target.value })}
          value={dataForm?.boxNo || ""}
        />
        <InputCreateProject
          placeholder={"شماره قفسه دارو را وارد کنید"}
          label="شماره قفسه"
          onChange={(e) =>
            setDataForm({ ...dataForm, shelfNo: e.target.value })
          }
          value={dataForm?.shelfNo || ""}
        />
      </Box>
    </>
  );
}
